import config from "../config/config";
import { getToken } from "../utils/prefix";

export async function task_register(data) {
  const res = await fetch(config.api_backend + `/member/create`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

// const res = await fetch(config.api_backend + `/member/getAll`, {
export async function get_task_member(data) {
  const res = await fetch(config.api_backend + `/member/all`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_options_member(data) {
  const res = await fetch(config.api_backend + `/member/alloptions`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function check_task_member(data) {
  const res = await fetch(config.api_backend + `/member/checkRole`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function update_task_member(data) {
  const res = await fetch(config.api_backend + `/member/updateRole`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function delete_task_member(data) {
  const res = await fetch(config.api_backend + `/member/deleteRole`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}
